module.exports = __webpack_public_path__ + "img/143.4.74d560b9.png";